export default "<router-outlet></router-outlet>\r\n<div (window:beforeunload)=\"clearAllData()\"></div>\r\n<app-loader></app-loader>\r\n";